import { render } from "./PosRightbar.vue?vue&type=template&id=699676c6&scoped=true"
import script from "./PosRightbar.vue?vue&type=script&lang=js"
export * from "./PosRightbar.vue?vue&type=script&lang=js"

import "./PosRightbar.vue?vue&type=style&index=0&id=699676c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699676c6"]])

export default __exports__